import { useEffect, useState } from "react";
import HookForm from "../../../components/HookForm/HookForm";
import getContainerCard from "../../../api/containers/getContainerCard";
import { useParams } from "react-router-dom";
import alert from "../../../helpers/alert";
import SelectMarks from "../../../components/Selects/SelectMarks";
import SelectModels from "../../../components/Selects/SelectModels";
import DocsInputNew from "../../../components/Inputs/DocsInput/DocsInputNew";
import editContainer from "../../../api/containers/editContainer";
import Header from "../../../components/Header/Header";
import formatNumber from "../../../utils/formatNumber";
import ContainerColorPhotos from "./ContainerColorPhotos";

// ÐÑÐ³ÑÑÐ¶Ð°ÑÑ Ð»Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð½Ð° Ð¥Ð°Ð»ÑÐº ÐÐ°ÑÐºÐµÑ. ÐÑÐ¸Ð·Ð½Ð°Ðº Ð¼Ð°ÑÐ¸Ð½Ñ (forApp) Ð¾Ð±ÑÐ¸Ð¹ Ð´Ð»Ñ
// ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð° Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ Ð¸ Ð²Ð¸ÑÑÐ¸Ð½Ñ Ð¿Ð»Ð¾ÑÐ°Ð´ÐºÐ¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð²ÑÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¹:
// Ð¥Ð°Ð»ÑÐº Ð¿ÑÐ¾ÑÐ¸Ð» Ð¿ÑÐ¸ÑÑÐ»Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°ÑÑÑ Ð¼Ð¾Ð´ÐµÐ»ÐµÐ¹, Ð° Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ Ð½ÑÐ¶Ð½Ñ Ð²ÑÐµ.
const HalykMarketField = ({ value, label, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <input
      type="checkbox"
      id="halykMarket"
      checked={!!value}
      onChange={(e) => onChange(e.target.checked)}
    />
    <label htmlFor="halykMarket">{label}</label>
  </div>
);
const formStyles = {
    carInfo: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr 1fr 1fr 1fr` },
    dealerInfo: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' },
    other: { display: 'grid', gap: '20px' },
  };
  
const CarContainerEdit = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]);
    // Ð¤Ð¾ÑÐ¼Ð° ÑÐ¸ÑÐ°ÐµÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð¿Ð¾Ð»ÐµÐ¹ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð·, Ð¿ÑÐ¸ Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸, Ð° ÐºÐ°ÑÑÐ¾ÑÐºÐ°
    // Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ Ñ ÑÐµÑÐ²ÐµÑÐ° Ð¿Ð¾Ð·Ð¶Ðµ. ÐÐµÐ· ÑÑÐ¾Ð³Ð¾ ÑÑÑÑÑÐ¸ÐºÐ° Ð³Ð°Ð»Ð¾ÑÐºÐ° Â«ÐÑÐ³ÑÑÐ¶Ð°ÑÑ Ð½Ð°
    // Halyk MarketÂ» Ð²ÑÐµÐ³Ð´Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð°ÑÑ Ð¿ÑÑÑÐ¾Ð¹ â Ð¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ Ð²ÑÐºÐ»ÑÑÐ°Ð»Ð¾
    // Ð²ÑÐ³ÑÑÐ·ÐºÑ, Ð´Ð°Ð¶Ðµ ÐµÑÐ»Ð¸ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¾Ð½Ð° Ð±ÑÐ»Ð° Ð²ÐºÐ»ÑÑÐµÐ½Ð°.
    const [formVersion, setFormVersion] = useState(0);

      const save = async (values) => {
        setLoading(true)
        try {
            await editContainer({
                containerId: id,
                photo: values?.photo,
                customPrice: values?.customPrice,
                halykMarket: values?.halykMarket
            });
            alert.success("ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ")
            update();
        } catch(e) {
            alert.error(e)
        } finally {
            setLoading(false)
        }
      }

      const update = async () => {
        setLoading(true)
        try {
            const res = await getContainerCard({ id });
            const container = res?.data?.container;

            setData([
                {
                    name: 'mark',
                    component: SelectMarks,
                    label: 'ÐÐ°ÑÐºÐ°',
                    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
                    defaultValue: { value: container?.mark?.id, label: container?.mark?.name },
                    disabled: true,
                  },
                  {
                    name: 'model',
                    component: SelectModels,
                    dependency: 'mark',
                    dependencyAccessor: (obj) => obj?.value,
                    label: 'ÐÐ¾Ð´ÐµÐ»Ñ',
                    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
                    defaultValue: { value: container?.model?.id, label: container?.model?.name },
                    disabled: true,
                  },
                  {
                    name: 'customPrice',
                    label: 'Ð¦ÐµÐ½Ð° Ð¾Ñ',
                    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½ÑÑ ÑÐµÐ½Ñ',
                    format: 'number',
                    defaultValue: formatNumber(container?.customPrice),
                  },
                  {
                    name: 'halykMarket',
                    label: 'ÐÑÐ³ÑÑÐ¶Ð°ÑÑ Ð½Ð° Halyk Market',
                    component: HalykMarketField,
                    defaultValue: container?.halykMarket !== false,
                  },
                  {
                    name: 'photo',
                    component: DocsInputNew,
                    label: 'Ð¤Ð¾ÑÐ¾',
                    text: 'Ð¤Ð¾ÑÐ¾',
                    id: Math.random(),
                    showImage: true,
                    imageUrl: container?.url,
                  }
            ])
            setFormVersion((prev) => prev + 1);
        } catch(e) {
            alert.error(e);
        } finally {
            setLoading(false)
        }
      }

      useEffect(() => {
        update();
      }, [])

    return(<>
        <Header title="Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¼Ð°ÑÐºÑ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ" />
        <HookForm key={formVersion} inputs={data} border grid={formStyles.carInfo} onSubmit={save} loading={loading} action="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ" />
        <ContainerColorPhotos containerId={id} />
    </>)
}

export default CarContainerEdit;